import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_GENERAL_IMG_SRC](state, p) {
    const drp = p.drp;
    drp.src = p.src;
  },
};

const actions = {
  setImgGeneralSrc: ({ commit }, payload) => {
    commit(types.SET_GENERAL_IMG_SRC, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/image-general/vuex.js